// extracted by mini-css-extract-plugin
module.exports = {"empty":"_19221"};